// Fixed Assets Getters

export const getFixedAssetsList = state => {
  return state.fixedAssetsList
}

export const getFixedAssetInfo = state => {
  return state.fixedAssetInfo
}

export const getFullFixedAssetsList = state => {
  return state.fullFixedAssetsList
}

export const getFullTransferFixedAssetsList = state => {
  return state.fullTransferFixedAssetsList
}
